import { Upload, Row, Col, Input, Button, Segmented, message } from 'antd'
import {
  PlusOutlined,
  LinkOutlined,
  DeleteOutlined,
  CopyOutlined,
  CheckOutlined
} from '@ant-design/icons'
import UploadItem from './UploadItem'
import { upLoadImagePostWeb } from '../../../services/postservice'
import { useState } from 'react'
import { validateImage360 } from '../helpers'

const Var360Upload = ({ value = [], onChange, max = 3 }) => {
  const [mode, setMode] = useState('upload')
  const [link, setLink] = useState('')
  const [copied, setCopied] = useState(false)
  /* ---------- Upload ---------- */
  const handleSelect = async (file) => {
    try {
      await validateImage360(file)
    } catch (err) {
      message.error(err)
      return Upload.LIST_IGNORE
    }

    if (value.length >= max) {
      message.error(`Tối đa ${max} ảnh`)
      return Upload.LIST_IGNORE
    }

    const id = `var360-${Date.now()}-${file.uid}`

    onChange([...value, { id, uploading: true, isLink: false }])

    try {
      const res = await upLoadImagePostWeb([file])
      if (res?.code === 200) {
        onChange((prev) =>
          prev.map((i) =>
            i.id === id ? { ...i, url: res.data, uploading: false } : i
          )
        )
      }
    } catch {
      onChange((prev) => prev.filter((i) => i.id !== id))
      message.error('Upload thất bại')
    }

    return false
  }

  /* ---------- Link ---------- */
  const handleAddLink = () => {
    if (!link.trim()) {
      message.error('Vui lòng nhập link ảnh')
      return
    }

    if (value.length >= max) {
      message.error(`Tối đa ${max} ảnh`)
      return
    }

    onChange([
      ...value,
      {
        id: `var360-link-${Date.now()}`,
        url: link.trim(),
        isLink: true
      }
    ])

    setLink('')
  }

  const handleRemove = (id) => {
    onChange(value.filter((i) => i.id !== id))
  }
  const handleCopy = (item) => {
    navigator.clipboard.writeText(item.url)
    setCopied(true)
    message.success('Đã copy link')

    setTimeout(() => {
      setCopied(false)
    }, 6000) // 6s (m đổi 5000–10000 tuỳ thích)
  }

  return (
    <>
      {/* Switch */}
      <Segmented
        value={mode}
        onChange={setMode}
        options={[
          { label: 'Upload 360', value: 'upload' },
          { label: 'Link', value: 'link' }
        ]}
        style={{ marginBottom: 12 }}
      />

      {/* Link input */}
      {mode === 'link' && (
        <Input.Search
          placeholder="Nhập link ảnh 360"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          onSearch={handleAddLink}
          enterButton={<Button icon={<LinkOutlined />}>Thêm</Button>}
          style={{ marginBottom: 12 }}
        />
      )}

      {/* List ảnh + Upload */}
      <Row gutter={[12, 12]}>
        {/* {value.map((item) => (
          <Col key={item.id}>
            <UploadItem image={item} onRemove={() => handleRemove(item.id)} />
          </Col>
        ))} */}

        {/* Ô thêm 360 nằm cạnh preview */}
        {mode === 'upload' && value.length < max && (
          <Col>
            <Upload
              accept="image/*"
              showUploadList={false}
              beforeUpload={handleSelect}
            >
              <div
                style={{
                  width: 76,
                  height: 76,
                  border: '1px dashed #d9d9d9',
                  borderRadius: 8,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: '#999'
                }}
              >
                <PlusOutlined style={{ fontSize: 20 }} />
                <div style={{ marginTop: 6, fontSize: 12 }}>360°</div>
              </div>
            </Upload>
          </Col>
        )}
      </Row>
      {value.map((item) => {
        return (
          <Col span={24} key={item.id}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                background: '#fafafa',
                marginTop: 12
              }}
            >
              {/* ICON 360 */}
              {/* <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 6,
            background: '#e6f4ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#1677ff',
            fontWeight: 600
          }}
        >
          360°
        </div> */}

              {/* LINK */}
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: 13
                  }}
                  title={item.url}
                >
                  {item.url}
                </div>
              </div>

              {/* COPY / CHECK ICON */}
              <div
                onClick={() => handleCopy(item)}
                style={{
                  cursor: 'pointer',
                  color: copied ? '#52c41a' : '#1677ff',
                  fontSize: 16
                }}
              >
                {copied ? <CheckOutlined /> : <CopyOutlined />}
              </div>

              {/* DELETE */}
              <DeleteOutlined
                onClick={() => handleRemove(item.id)}
                style={{
                  color: '#ff4d4f',
                  fontSize: 16,
                  cursor: 'pointer'
                }}
              />
            </div>
          </Col>
        )
      })}
    </>
  )
}

export default Var360Upload
